import React, { createContext, useContext, useEffect, useState } from "react";

const EnquiryCtx = createContext(null);
const KEY = "rextech_enquiry_v1";

export function EnquiryProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);
  const add = (product, qty = 1) => {
    setItems(prev => {
      const exist = prev.find(i => i.product_id === product.id);
      if (exist) return prev.map(i => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, { product_id: product.id, product_name: product.name, image: product.images?.[0] || "", quantity: qty }];
    });
  };
  const remove = (pid) => setItems(prev => prev.filter(i => i.product_id !== pid));
  const setQty = (pid, q) => setItems(prev => prev.map(i => i.product_id === pid ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  return <EnquiryCtx.Provider value={{ items, add, remove, setQty, clear, count }}>{children}</EnquiryCtx.Provider>;
}
export const useEnquiry = () => useContext(EnquiryCtx);
